var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("糖尿病被认为是21世纪的一大瘟疫。据估计，高达20%的糖尿病患者需要住院治疗，因为足部出现溃疡，再加上循环系统的问题，如果再加上缺乏冲洗和感染的情况，这种情况会在不止几次的情况下导致肢体丧失。")]),_vm._v(" "),_c('p',[_vm._v("因此，糖尿病足的治疗和治疗需要多学科的方法。在Centro Bioenergy，我们专门关注是否作为基于草药产品的辅助产品、中西医结合以及不同医疗外科技术的应用。")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c441b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s3.vue
// module id = null
// module chunks = 